import * as React from 'react';
import * as PropTypes from 'prop-types';
import styles from '../Tour.module.scss';

const TourTooltip = (props) => {
  const { index, size, step, primaryProps, tooltipProps, skipProps, backProps } = props;
  const isHideSkipButton = step.hideSkipButton;

  return (
    <>
      <div {...tooltipProps} title={''} className={styles.tooltipContent}>
        <div>{step.content}</div>
        <div className={styles.buttonsGroup}>
          {!isHideSkipButton && (
            <div {...skipProps} title={''} className={styles.defaultButton}>
              {skipProps['aria-label']}
            </div>
          )}
          <div className={styles.navigateButtonGroup}>
            {index !== 0 && (
              <div {...backProps} title={''} className={styles.defaultButton}>
                {backProps['aria-label']}
              </div>
            )}
            <div {...primaryProps} className={styles.primaryButton} title={''}>
              <span>
                {primaryProps['aria-label']}
                {step.showProgress ? ` (${index + 1}/${size})` : ''}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

TourTooltip.propTypes = {
  index: PropTypes.number,
  size: PropTypes.number,
  step: PropTypes.object,
  primaryProps: PropTypes.object,
  tooltipProps: PropTypes.object,
  skipProps: PropTypes.object,
  backProps: PropTypes.object,
};

export default TourTooltip;
